import { Type } from "@linkfluence/models/notification";
import { notify } from "./toast";

const notifyType = (message: string, type: Type, description, error) =>
  notify(message, type, description, error);

export function notifySuccess(
  message: string,
  description?: string,
  error?: string
) {
  notifyType(message, Type.Success, description, error);
}

export function notifyError(
  message: string,
  description?: string,
  error?: string
) {
  notify(message, Type.Error, description, error);
}

export function notifyInfo(
  message: string,
  description?: string,
  error?: string
) {
  notify(message, Type.Info, description, error);
}

export function notifyWarning(
  message: string,
  description?: string,
  error?: string
) {
  notify(message, Type.Warning, description, error);
}
